import { render, staticRenderFns } from "./managementChart.vue?vue&type=template&id=2d95f671&scoped=true"
import script from "./managementChart.vue?vue&type=script&lang=js"
export * from "./managementChart.vue?vue&type=script&lang=js"
import style0 from "./managementChart.vue?vue&type=style&index=0&id=2d95f671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95f671",
  null
  
)

export default component.exports